module.exports = __webpack_public_path__ + "img/banner.5c376f1d.jpg";